import { BaseError, type BaseErrorOptions, createErrorClass } from '@canvas/error';

export class CanvasRendererError extends BaseError {
  originalError?: Error;

  constructor(message: string, options?: BaseErrorOptions) {
    super({ name: 'CanvasRendererError', ...options }, message);
  }

  static from(rawError: unknown): CanvasRendererError {
    const err = rawError instanceof Error ? rawError : new Error(String(rawError));
    const rendererError = new CanvasRendererError(err.message);
    rendererError.stack = err.stack;
    rendererError.originalError = err;
    rendererError.ignoreUfoReporting =
      err instanceof BaseError ? err.ignoreUfoReporting : false;
    return rendererError;
  }
}

export const RecoverableWebGlError = createErrorClass('RecoverableWebGlError');
export const UnrecoverableWebGlError = createErrorClass('UnrecoverableWebGlError');
